import { getOrganizationOfUser } from '@upright/common/iam/organizations/common';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { useFrontPageConfig } from '@upright/ui/views/home-views/front-page-config';
import { type UnifiedShellAudience, unifiedShellAudience } from './unified-shell-audience';

/**
 * The signed-in user's unified shell audience: investor, company or none. The one place the
 * shell, the launcher gate, the rail choice and the home at `/` read it from, so they cannot
 * disagree. See `unifiedShellAudience` for the rule.
 *
 * The organisation is the user's own (`getOrganizationOfUser`): the team's organisation for a team
 * user, the first non-Arvo one otherwise. No active user belongs to both a Company organisation and
 * an investor-type one (October 2026), so which of several it picks does not yet change the shell.
 */
export function useUnifiedShellAudience(): UnifiedShellAudience {
  const { frontPage } = useFrontPageConfig();
  const user = useGetLoggedInUser();
  return unifiedShellAudience({
    frontPage,
    organizationType: user ? getOrganizationOfUser(user)?.type : undefined,
  });
}
